import { atom } from "recoil";
import {
  PROMOTION_DATA_KEY,
  readPromotionData,
  writePromotionData,
  clearAllPromotionStorage,
} from "../utils/promotionOnboardingStorage";

interface OnboardingDataState {
  [pageKey: string]: DataState; // pageKey key로 하여 SelectState를 값으로 담는 객체
}

export interface QA {
  questionId: number;
  answerId: number;
}

export interface DataState {
  multiSelectionIdList?: number[];
  singleSelectionId?: number;
  qaList?: QA[];
  text?: string;
}

// 키/만료/삭제 로직은 utils에서 공통 관리

/*
  Atom Effects:
  - setSelf: atom 초깃값을 세팅
  - onSet: atom 값이 바뀔 때 호출
*/
const localStorageEffect =
  (key: string) =>
  ({ setSelf, onSet }: any) => {
    // ① 초기값 로드 (만료 시 관련 스토리지 일괄 삭제)
    const restored = readPromotionData<OnboardingDataState>();
    if (restored) {
      setSelf(restored);
    }

    // ② 변경 시 저장 + 로그 (utils 공통 사용)
    onSet(
      (newValue: OnboardingDataState, _: OnboardingDataState, __: boolean) => {
        try {
          writePromotionData(newValue);
        } catch (e) {
          console.warn("Failed to persist onboardingPromotionDataState:", e);
        }
      }
    );
  };

export const onboardingPromotionDataState = atom<OnboardingDataState>({
  key: "onboardingPromotionDataState",
  default: {},
  effects: [
    localStorageEffect(PROMOTION_DATA_KEY),
    // ↑ onSet / setSelf 로컬스토리지 연동
  ],
});